import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchCertifiers(agro_exporter_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_providers/${agro_exporter_id}/fetch_certifiers`
    );
  },

  manage(
    agro_exporter_id,
    provider_type,
    provider_id,
    provider_params
  ) {
    return RequesterV1.post(
      `agro_exporter/certifications/providers/manage_providers/${agro_exporter_id}/manage/${provider_type}/${provider_id}`,
      { provider: provider_params }
    );
  }
};
